/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ApplicationHealthBatchResponse {
    getFixupPrototypeFunction() { return ApplicationHealthBatchResponse.fixupPrototype; }

    static newInstance(model: Partial<ApplicationHealthBatchResponse>): ApplicationHealthBatchResponse {
        let obj = Object.assign(new ApplicationHealthBatchResponse(), model);
        ApplicationHealthBatchResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ApplicationHealthBatchResponse>): ApplicationHealthBatchResponse {
        if (!model) return null;
        return ApplicationHealthBatchResponse.newInstance(<ApplicationHealthBatchResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ApplicationHealthBatchResponse) {
        if (!obj) return;

        models.ApplicationHealthBatchResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ApplicationHealthBatchResponse): boolean {
        Object.setPrototypeOf(obj, ApplicationHealthBatchResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.results) {
            for (let key in this.results) {
                let val = this.results[key];
                if (val) {
                    models.ApplicationHealthSummary.fixupPrototype(val);
                }
            }
        }
    }

    /**
     * Map from identifier to response model
     */
    results: { [key: string]: models.ApplicationHealthSummary; };

}
